import { MarketDetailsResponse } from '../../types/markets/types';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { get } from '../apiService';

export const getMarketDetails = async (
  marketId: string
): Promise<{
  data: MarketDetailsResponse | null;
  loading: boolean;
}> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer ID is not available');
  }

  // Construct the URL with the required parameters
  const url = `resourceMatrix/market/get?customerId=${customer}&marketId=${marketId}`;

  let loading = true;

  try {
    // Make the API call
    const responseData = await get(url);
    const data = responseData as MarketDetailsResponse;
    loading = false;
    return { data, loading };
  } catch (error) {
    // Handle errors gracefully
    loading = false;
    console.error('Failed to fetch market details:', error);
    throw new Error('Failed to fetch market details');
  }
};
